import { type SxProps, type Theme } from "@mui/material";

/** On the glyph itself, so it wins over the `text.primary` the field gives a start icon. */
export const SEARCH_GLYPH_SX: SxProps<Theme> = (theme) => ({ color: theme.palette.primary.main });
